module.exports = __webpack_public_path__ + "img/oil.c657539c.png";